import React from 'react'
import { connect } from 'react-redux'
import { UNIFIED_DISCLAIMER, BRAND_ENDPOINTS } from '../../configuration/terms'

const getUrlEndpoint = brandLetter => {
  let endpoint = ''

  switch (brandLetter) {
    case 'R':
      endpoint = BRAND_ENDPOINTS[brandLetter]
      break

    case 'C':
      endpoint = BRAND_ENDPOINTS[brandLetter]
      break

    default:
      endpoint = BRAND_ENDPOINTS.R + ' and ' + BRAND_ENDPOINTS.C
  }

  return endpoint
}

const TermsAndConditions = props => {
  const brand = props?.activePackage?.brand
  let disclaimerRaw = UNIFIED_DISCLAIMER
  const disclaimer = disclaimerRaw.replaceAll(
    '{brandUrl}',
    getUrlEndpoint(brand)
  )

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: disclaimer
      }}
    />
  )
}

const mapStateToProps = state => {
  const activePackage = state?.availablePackages[state?.activePackage] || {}

  return {
    activePackage
  }
}

export default connect(mapStateToProps)(TermsAndConditions)
